import config from '../../../../../config/config';

export const RAIZ_ESCUELA = 'escuela';

// Pantallas de cuenta: nunca son un destino válido para "volver" (se entraría en un bucle de ingreso).
const PANTALLAS_CUENTA = ['ingresar', 'registro', 'verificar-correo', 'recuperar-contrasena'];

// Comandos de navegación hacia la escuela pública, antepuestos del URL_BASE_PATH de la app (igual que el
// resto de rutas del layout Simple en app.routes.ts). Centralizado para no concatenar '/' + base +
// '/escuela' en cada componente: con un URL_BASE_PATH vacío esa concatenación produciría '//escuela'.
export function rutaEscuela(...segmentos: (string | number)[]): (string | number)[] {
  return ['/', ...[config.URL_BASE_PATH].filter(Boolean), RAIZ_ESCUELA, ...segmentos];
}

// Otras páginas públicas del sitio (política de privacidad, términos), fuera de la escuela.
export function rutaSitio(...segmentos: (string | number)[]): (string | number)[] {
  return ['/', ...[config.URL_BASE_PATH].filter(Boolean), ...segmentos];
}

// Valida el query param "volver" antes de navegar a él: solo rutas internas de la escuela, para que un
// enlace armado por un tercero no pueda sacar al alumno del sitio después de ingresar (open redirect).
export function destinoSeguroEscuela(volver: string | null | undefined): string | null {
  if (!volver || !volver.startsWith('/') || volver.startsWith('//') || volver.includes('\\')) {
    return null;
  }
  const prefijo = '/' + [config.URL_BASE_PATH, RAIZ_ESCUELA].filter(Boolean).join('/');
  const ruta = volver.split(/[?#]/)[0];
  if (ruta !== prefijo && !ruta.startsWith(prefijo + '/')) {
    return null;
  }
  const primerSegmento = ruta.slice(prefijo.length).split('/').filter(Boolean)[0];
  return PANTALLAS_CUENTA.includes(primerSegmento) ? null : volver;
}
